'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSimCard = function MdSimCard(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 25v-6.6h-3.4v6.6h3.4z m-6.8-3.4v-3.2h-3.2v3.2h3.2z m0 10v-6.6h-3.2v6.6h3.2z m-6.6-6.6v-6.6h-3.4v6.6h3.4z m13.4 6.6v-3.2h-3.4v3.2h3.4z m-13.4 0v-3.2h-3.4v3.2h3.4z m18.3-25l0.1 26.8c0 1.8-1.6 3.2-3.4 3.2h-20c-1.8 0-3.4-1.4-3.4-3.2v-20l10-10h13.4c1.8 0 3.3 1.4 3.3 3.2z' })
        )
    );
};

exports.default = MdSimCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/sim-card.js
// module id = 1922
// module chunks = 168707334958949